<script lang="ts" setup>
  import { useI18n } from 'vue-i18n'

  const { prerequisite } = useAppInit()
  const { t } = useI18n()
  const route = useRoute()
  const router = useRouter()

  function handleContact() {
    router.push({ ...route, query: { modal: 'contact' } })
  }
</script>

<template>
  <div class="c-nav-menu">
    <NuxtLink
      to="/"
      class="icon-label"
    >
      <SvgIcon
        icon="explorer"
        :width="20"
        :height="20"
      />
      <span class="label">{{ t("navigation.search") }}</span>
    </NuxtLink>
    <NuxtLink
      v-if="prerequisite?.data?.has_promotions"
      to="/promotions"
      class="icon-label"
    >
      <SvgIcon
        icon="promotion-colored"
        :width="20"
        :height="20"
      />
      <span class="label">{{ t("navigation.promotions") }}</span>
    </NuxtLink>
    <NuxtLink
      to="/join-us"
      class="icon-label"
    >
      <SvgIcon
        icon="business"
        :width="20"
        :height="20"
      />
      <span class="label">{{ t("navigation.golf-manager") }}</span>
    </NuxtLink>
    <button
      class="icon-label"
      @click="handleContact"
    >
      <SvgIcon
        icon="contact"
        :width="20"
        :height="20"
      />
      <span class="label">{{ $t("navigation.contact") }}</span>
    </button>
  </div>
</template>

<style scoped>

.c-nav-menu {
  &.light-column {
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;

    .icon-label {
      display: flex;
      flex-direction: row;
      margin: 1rem 0;

      .c-icon {
        margin-right: 1rem;
        color: var(--color-primary);
      }

      .label {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 1.125rem;
        font-weight: 600;
        line-height: 1.33;
      }
    }
  }

  &.dark-row {
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;

    .icon-label {
      display: flex;
      flex-direction: row;
      margin: 2em 0.5em;

      .c-icon {
        margin-right: 0.5rem;
        color: var(--color-primary);
      }

      .label {
        color: white;
        font-family: Open-Sans, sans-serif;
        font-size: 1em;
        font-weight: 600;
        white-space: nowrap;
      }
    }
  }

  @media screen and (width >= 1024px) {
    &.dark-row {
      .icon-label {
        .label {
          letter-spacing: -0.25px;
        }
      }
    }
  }

  @media screen and (width >= 1152px) {
    &.dark-row {
      .icon-label {
        margin: 2em 0.75em;

        .label {
          font-size: 1.125em;
          letter-spacing: 0;
        }
      }
    }
  }

  @media screen and (width >= 1280px) {
    &.dark-row {
      .icon-label {
        margin: 2em 1em;

        .label {
          font-size: 1.125em;
        }
      }
    }
  }
}
</style>
